"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSegmentHasNextModeWidgetConfig = void 0;
/*
 * Copyright 2024, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const LodashExtensions_1 = require("chaire-lib-common/lib/utils/LodashExtensions");
const helpers_1 = require("../../../../utils/helpers");
const odHelpers = __importStar(require("../../../odSurvey/helpers"));
const types_1 = require("../../../odSurvey/types");
const helpers_2 = require("./helpers");
const getSegmentHasNextModeWidgetConfig = (
// FIXME: Type this when there is a few more widgets implemented
options = {}) => {
    return {
        type: 'question',
        path: 'hasNextMode',
        inputType: 'radio',
        twoColumns: false,
        datatype: 'boolean',
        label: (t, interview) => {
            var _a, _b;
            const person = odHelpers.getPerson({ interview });
            const journey = odHelpers.getActiveJourney({ interview, person });
            const trip = odHelpers.getActiveTrip({ interview, journey });
            const visitedPlaces = odHelpers.getVisitedPlaces({ journey });
            const origin = trip ? odHelpers.getOrigin({ trip, visitedPlaces }) : undefined;
            const destination = trip ? odHelpers.getDestination({ trip, visitedPlaces }) : undefined;
            const destinationActivity = destination ? destination.activity : '';
            const tripLoopActivity = (origin === null || origin === void 0 ? void 0 : origin.activity) && types_1.loopActivities.includes(origin.activity)
                ? origin.activity
                : destinationActivity && types_1.loopActivities.includes(destinationActivity)
                    ? destinationActivity
                    : undefined;
            if (tripLoopActivity) {
                return t(['customSurvey:segments:SegmentHasNextModeLoop', 'segments:SegmentHasNextModeLoop'], {
                    context: (_a = options.context) === null || _a === void 0 ? void 0 : _a.call(options),
                    nickname: person.nickname,
                    thisTrip: t(['customSurvey:thisTrip', 'survey:thisTrip'], { context: tripLoopActivity }),
                    count: odHelpers.getCountOrSelfDeclared({ interview, person })
                });
            }
            const destinationName = destination
                ? odHelpers.getVisitedPlaceName({ t, visitedPlace: destination, interview })
                : t(['customSurvey:survey:destination', 'survey:destination']);
            return t(['customSurvey:segments:SegmentHasNextMode', 'segments:SegmentHasNextMode'], {
                context: (_b = options.context) === null || _b === void 0 ? void 0 : _b.call(options),
                nickname: person.nickname,
                thisTrip: t(['customSurvey:thisTrip', 'survey:thisTrip'], { context: destinationActivity }),
                destinationName,
                count: odHelpers.getCountOrSelfDeclared({ interview, person })
            });
        },
        choices: [
            {
                value: true,
                label: (t) => t('survey:Yes')
            },
            {
                value: false,
                label: (t) => t('survey:No')
            }
        ],
        validations: function (value) {
            return [
                {
                    validation: (0, LodashExtensions_1._isBlank)(value),
                    errorMessage: (t) => t(['customSurvey:ResponseIsRequired', 'survey:ResponseIsRequired'])
                }
            ];
        },
        conditional: (interview, path) => {
            const segment = (0, helpers_1.getResponse)(interview, path, null, '../');
            const shouldShowSameAsReverseTrip = (0, helpers_2.shouldShowSameAsReverseTripQuestion)({ interview, segment });
            // Do not show if the question of the same mode as previous trip is shown and the answer is not 'no'
            if (shouldShowSameAsReverseTrip && segment.sameModeAsReverseTrip !== false) {
                if (segment.sameModeAsReverseTrip === true) {
                    // If the question of the same mode as previous trip is shown and the answer is yes, then there is no next mode
                    const previousTripSegment = (0, helpers_2.getPreviousTripSingleSegment)({
                        interview,
                        person: odHelpers.getActivePerson({ interview })
                    });
                    if (previousTripSegment && previousTripSegment.modePre !== undefined) {
                        return [false, false];
                    }
                }
                // Otherwise, initialize to null
                return [false, null];
            }
            // Otherwise, get the segments of the current trip and show only for the last segment
            const trip = odHelpers.getActiveTrip({ interview });
            const segments = (trip === null || trip === void 0 ? void 0 : trip.segments) ? trip.segments : {};
            const segmentsArray = Object.values(segments).sort((segmentA, segmentB) => {
                return segmentA['_sequence'] - segmentB['_sequence'];
            });
            const lastSegment = segmentsArray[segmentsArray.length - 1];
            if (!lastSegment || segmentsArray.length === 1 || segment._sequence === lastSegment._sequence) {
                return [true, null];
            }
            return [false, true];
        }
    };
};
exports.getSegmentHasNextModeWidgetConfig = getSegmentHasNextModeWidgetConfig;
//# sourceMappingURL=widgetSegmentHasNextMode.js.map